import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { customAxisOptions } from "./constants";
import type { CustomAxis } from "@/types/ab-tests";

interface CustomAxesSelectorProps {
  customAxes: CustomAxis[];
  onToggle: (axis: CustomAxis) => void;
}

export function CustomAxesSelector({ customAxes, onToggle }: CustomAxesSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Dimensions being tested</Label>
      <div className="space-y-2.5">
        {customAxisOptions.map((axis) => (
          <div key={axis.id} className="flex items-center gap-2">
            <Checkbox
              id={`edit-axis-${axis.id}`}
              checked={customAxes.includes(axis.id)}
              onCheckedChange={() => onToggle(axis.id)}
            />
            <label htmlFor={`edit-axis-${axis.id}`} className="text-sm cursor-pointer select-none">
              {axis.label}
            </label>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Tag the axes your variant changes. These power filtering and reporting.</p>
    </div>
  );
}
